import React from "react";

import { createCtx } from "./context";

export interface IUserPermissions {
  canAccessAIAssistant: boolean;
  canAccessModern360: boolean;
  canAccessPhoenixELDUnidentifiedDriving: boolean;
  canCreateGeofence: boolean;
  canEditUnidentifiedDriverLogs: boolean;
  canRouteToLocation: boolean;
  canViewAlerts: boolean;
  canViewGeofence: boolean;
  canEditGeofence: boolean;
}

export type UserStore = {
  permissions: IUserPermissions;
  areaPermissions: string[];
};

export const [useUserContext, UserContextProvider] = createCtx<UserStore | undefined>();
const UserActionsContext = React.createContext<(userStore: Partial<UserStore>) => void>(() => {});
export const useUserActionsContext = (): ((userStore: Partial<UserStore>) => void) => {
  const context = React.useContext(UserActionsContext);
  if (context === undefined) {
    throw new Error(`Context must be called within Provider`);
  }
  return context;
};

type Props = { children: React.ReactNode };

export const defaultStore: UserStore = {
  permissions: {
    canAccessAIAssistant: false,
    canAccessModern360: false,
    canAccessPhoenixELDUnidentifiedDriving: false,
    canCreateGeofence: false,
    canEditUnidentifiedDriverLogs: false,
    canRouteToLocation: false,
    canViewAlerts: false,
    canViewGeofence: false,
    canEditGeofence: false,
  },
  areaPermissions: [],
};

export const UserProvider = ({ children }: Props): React.ReactElement => {
  const [userStore, setUserStore] = React.useState<UserStore>(defaultStore);

  return (
    <UserContextProvider value={userStore}>
      <UserActionsContext.Provider
        value={(store: Partial<UserStore>) =>
          setUserStore((prev: $TSFixMe) => ({
            ...prev,
            ...store,
          }))
        }
      >
        {children}
      </UserActionsContext.Provider>
    </UserContextProvider>
  );
};
